import template from './shiptype.create.html';
import controller from './shiptype.create.controller';
import './shiptype.create.scss';

let shiptypeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default shiptypeCreateComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/create/shiptype.create.component.js